// Generated prop information for CartWidget
const propList = [
  "position",
  "size",
  "xMargin",
  "yMargin",
  "onCheckout",
  "fluidShopDisplayName",
  "hideWidget",
  "demoMode",
  "demoCart"
];
export default propList;

// Detailed prop information with types
export const propInfo = [
  {
    "name": "position",
    "type": "string",
    "optional": true
  },
  {
    "name": "size",
    "type": "number",
    "optional": true
  },
  {
    "name": "xMargin",
    "type": "number",
    "optional": true
  },
  {
    "name": "yMargin",
    "type": "number",
    "optional": true
  },
  {
    "name": "onCheckout",
    "type": "function",
    "optional": true
  },
  {
    "name": "fluidShopDisplayName",
    "type": "string",
    "optional": true
  },
  {
    "name": "hideWidget",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "demoMode",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "demoCart",
    "type": "string",
    "optional": true
  }
];
